import { createApiStreamRouteInvoker } from '../../../../../shared/backend/transports/apiStream';
import { auth } from '@/firebaseConfig';
import { backendConfig } from '../config';
import { normalizeApiError } from '../errors';

export const invokeApiStreamRoute = createApiStreamRouteInvoker({
  apiBaseUrl: backendConfig.apiBaseUrl,
  getIdToken: async () => auth.currentUser?.getIdToken(),
  normalizeApiError,
});
